@if (puffs() && puffs().length > 0) {
  <h2 class="text-2xl font-bold mb-6">Det senaste på bloggen</h2>

  <aside>
    <div class="flex flex-col gap-4">
      @for (puff of puffs(); track puff.id) {
        <div class="flex flex-row gap-3 items-start justify-start">
          <app-media-item
            [classList]="'object-center object-cover w-auto h-full'"
            [image]="puff.acf.mainImage"
            [isNarrowColumnImage]="true"
            [isPriority]="false"
            [routePath]="puff.routePath"
            class="w-[5.5rem] h-[5.5rem] min-w-[5.5rem] basis-[5.5rem] rounded-lg overflow-hidden inline-block"
          ></app-media-item>

          <div class="grow line-clamp-4">
            <a
              [innerHTML]="puff.title.rendered"
              [routerLink]="puff.routePath"
              class="block text-left font-bold text-black"
            ></a>
            <div [innerHTML]="puff.acf.puffDescription" class="text-black text-sm"></div>
          </div>
        </div>
      }

      <a [routerLink]="blogLink()" class="text-lg font-bold">
        Se fler inlägg på bloggen &nbsp;
        <app-ui-icon
          class="align-text-top"
          color="rgba(5, 95, 114, 1)"
          name="arrow_right"
          size="md"
        ></app-ui-icon>
      </a>
    </div>
  </aside>
}

